import { Container, Graphics } from "pixi.js";

/** Geometry is built once; flight only changes transforms and opacity. */
export class EnginePlume {
  readonly container = new Container({ label: "engine-plume" });
  private readonly halo = new Graphics()
    .ellipse(-8, 0, 21, 10)
    .fill({ color: 0xffffff, alpha: 0.04 })
    .ellipse(-7, 0, 16, 7)
    .fill({ color: 0xffffff, alpha: 0.08 })
    .ellipse(-5, 0, 10, 5)
    .fill({ color: 0xffffff, alpha: 0.16 });
  private readonly exhaust = new Graphics()
    .poly([0, -5, -9, -4, -32, 0, -9, 4, 0, 5])
    .fill({ color: 0xffffff, alpha: 0.55 });
  private readonly core = new Graphics()
    .poly([0, -2.5, -9, -2, -22, 0, -9, 2, 0, 2.5])
    .fill({ color: 0xe9fbff, alpha: 0.95 });

  constructor() {
    this.container.addChild(this.halo, this.exhaust, this.core);
    this.container.blendMode = "add";
    this.container.visible = false;
  }

  render(
    length: number,
    moving: boolean,
    boosting: boolean,
    hostile: boolean,
    now: number,
  ): void {
    this.container.visible = moving;
    if (!moving) return;
    this.container.x = -length * 0.39;
    const pulse = 0.94 + Math.sin(now / 54 + length) * 0.06;
    const strength = boosting ? 2.3 : 0.9;
    this.exhaust.tint = this.halo.tint = hostile ? 0xff9460 : 0x48bdff;
    this.exhaust.scale.set(strength * pulse, boosting ? 1.25 : 0.9);
    this.core.scale.set(strength * pulse, boosting ? 1.1 : 0.8);
    this.halo.scale.set(boosting ? 1.6 : 1, boosting ? 1.45 : 0.9);
    this.container.alpha = boosting ? 0.95 : 0.72;
  }
}
